import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { requestGetUserList } from '@app/services/UserService';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";

const NLMySelfOrAll = ({
    initData,
    onChange
}) => {
    const [searchConditions, setSearchConditions] = useState({})

    const [userOptions, setUserOptions] = useState([]);
    const [userSearchOptions, setUserSearchOptions] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const fetchUsers = async () => {
        const res = await requestGetUserList({});
        const userList = res.content.users
        const userOptionList = userList.map(user => {
            return  {value: user.id, label : user.email, id: user.id}
        })
        setUserSearchOptions([...userOptionList])
        userOptionList.splice(0, 0, {value: "", label : "Chọn user", id: ""})
        setUserOptions(userOptionList);
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    },[]);

    useEffect(() => {
        if (initData) {
            setSearchConditions(initData)
        }
    }, [initData]);

    useEffect(() => {
        if (userLoginInfo.is_superuser) {
            fetchUsers();   
        }
    }, [userLoginInfo]);


    const onChangeCreatedUserCondition = (values) => {
        searchConditions.created_by_user = values;
        setSearchConditions({...searchConditions});
    };
    
    const onChangeInputtedUserCondition = (values) => {
        searchConditions.inputted_by_user = values;
        setSearchConditions({...searchConditions});
    };

    const setSearchOnlyInputByMyselfConditionItem = (event) => {
        const value = searchConditions[event.target.name]
        if (value) {
            // Reset choose inputted users
            onChangeInputtedUserCondition([])
        }
        searchConditions[event.target.name] = !value;
        setSearchConditions({...searchConditions});
    };

    const setSearchAdvanceOnlyInputByMyselfConditionItem = (event) => {
        const value = searchConditions.advances[event.target.name]
        searchConditions.advances[event.target.name] = !value;
        setSearchConditions({...searchConditions});
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>NL của mình/Tất cả</h3>
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label>Chỉ NL của mình</label>
                    <input type="checkbox"
                            className="ml-3" name={'only_user_input'}
                            style={{width: 20, height: 20}}
                            value={!!searchConditions.only_user_input}
                            checked={searchConditions.only_user_input === true}
                            onChange={event => setSearchOnlyInputByMyselfConditionItem(event)}/>
                </div>
                {searchConditions.only_user_input === false && userLoginInfo.is_superuser &&
                <div className='input-group'>
                    <div style={{width: '100%'}}>
                        <label>NL bởi users</label>
                        <Select options={userSearchOptions}
                                isMulti
                                placeholder={"Tất cả users"}
                            // isDisabled={searchConditions.hide_show.is_select_all_users}
                                value={searchConditions.inputted_by_user}
                                onChange={values => {
                                    onChangeInputtedUserCondition(values);
                                }}
                        />
                    </div>
                </div>}

                {userLoginInfo.is_superuser &&
                <div className='input-group mt-2'>
                    <label className={"w-100"}>NL mới bởi users</label>
                    <div style={{width: '100%'}}>
                        <Select options={userOptions}
                                value={searchConditions.created_by_user ? searchConditions.created_by_user : ''}
                                onChange={value => {
                                    onChangeCreatedUserCondition(value);
                                }}
                        />
                    </div>
                </div>
                }
            </div>
        </div>
    );
};

export default NLMySelfOrAll;
